import { Trans, useLingui } from '@lingui/react/macro';

import { Trait } from '@/api';
import Checkbox from '@/design_system/Checkbox';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import { TRAITS } from '@/models/entity';

export const TraitsCheckboxes = ({
  traits,
  onChange,
}: {
  traits: Trait[];
  onChange: (traits: Trait[]) => void;
}) => {
  const { i18n } = useLingui();

  return (
    <Stack gap="0.25rem">
      <Paragraph weight="medium">
        <Trans id="settings.organization.data-catalogs.condition-forms.detail.question.traits">
          Entities:
        </Trans>
      </Paragraph>
      <Stack row gap="0.5rem">
        {TRAITS.filter(({ id }) => ['store', 'workshop'].includes(id)).map((trait) => (
          <Checkbox
            key={trait.id}
            value={trait.id}
            isSelected={traits.includes(trait.id)}
            onChange={(checked) => {
              if (checked) {
                onChange([...traits, trait.id]);
              } else {
                onChange(traits.filter((t) => t !== trait.id));
              }
            }}
          >
            {i18n._(trait.label)}
          </Checkbox>
        ))}
      </Stack>
    </Stack>
  );
};
